<script setup lang="ts">
import { Button } from '@/components/ui/button';

defineProps<{
  currentPage: number;
  numberOfPages: number;
  startEntry: number;
  endEntry: number;
  total: number;
}>();

const emit = defineEmits<{ 'go-to-page': [page: number] }>();
</script>

<template>
  <div class="flex flex-col gap-3 border-t border-gray-200 px-4 pt-3 sm:flex-row sm:items-center sm:justify-between">
    <p class="text-sm text-slate-600">
      Showing <span class="font-medium text-slate-900">{{ startEntry }}</span> to
      <span class="font-medium text-slate-900">{{ endEntry }}</span> of
      <span class="font-medium text-slate-900">{{ total }}</span>
    </p>

    <div class="flex items-center gap-2">
      <Button size="sm" variant="outline" :disabled="currentPage <= 1" @click="emit('go-to-page', currentPage - 1)">
        Previous
      </Button>
      <span class="min-w-[88px] text-center text-sm text-slate-500">Page {{ currentPage }} of {{ numberOfPages }}</span>
      <Button
        size="sm"
        variant="outline"
        :disabled="currentPage >= numberOfPages"
        @click="emit('go-to-page', currentPage + 1)"
      >
        Next
      </Button>
    </div>
  </div>
</template>
